<template>
	<div :id="id" class="hidden">
		<div>isAuth : {{ isAuth }}</div>
		<div>Login URL : {{ loginUrl }}</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'BmedConfig',
	props: {
		id: {
			type: String,
			default: 'bmedConfig'
		},
		pageMode: {
			type: String,
			default: 'web'
		},
		userToken: {
			type: String,
			default: null
		},
		isAuth: {
			type: String,
			default: 'false'
		},
		loginUrl: {
			type: String,
			default: process.env.VUE_APP_LOGIN_REDIRECT
		},
		claimCreditUrl: {
			type: String,
			default: process.env.VUE_APP_CLAIM_CREDIT_URL
		},
		logoutFunction: {
			type: Function,
			default: () => {
				console.log('log out')
			}
		},
		baseUrl: {
			type: String,
			default: '/'
		}
	},
	mounted() {
		store.dispatch('getCategories')
		store.dispatch('getBreakingNews')
		store.dispatch('setBaseUrl', this.baseUrl)
		store.dispatch('setPageMode', this.pageMode)
		store.dispatch('setUserToken', this.userToken)
		store.dispatch('setLoginUrl', this.loginUrl)
		store.dispatch('setClaimCreditUrl', this.claimCreditUrl)
		store.dispatch('setLogoutFunction', this.logoutFunction)
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>